
import Vue from 'vue';
import { CvHeader, CvHeaderName, CvButton } from '@carbon/vue';
import ArrowLeft20 from '@carbon/icons-vue/es/arrow--left/20';

export default Vue.extend({
  name: 'WizardHeader',
  components: {
    CvHeader,
    CvHeaderName,
    CvButton,
    ArrowLeft20,
  },
  props: {
    buttonLabel: {
      type: String,
      default: '',
    },
    productName: {
      type: String,
      default: '',
    },
  },
  methods: {
    sendEvent() {
      this.$emit('header:back-button-click');
    },
  },
});
